import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-xl-4 col-md-6 mb-4"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row no-gutters align-items-center" }
const _hoisted_7 = { class: "col mr-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-success text-uppercase mb-1" }, " Fiat Revenue ", -1)
const _hoisted_9 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fas fa-fas fa-money-bill-alt fa-2x text-gray-300" })
], -1)
const _hoisted_11 = {
  key: 1,
  class: "col-xl-4 col-md-6 mb-4"
}
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "row no-gutters align-items-center" }
const _hoisted_14 = { class: "col mr-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-warning text-uppercase mb-1" }, " Crypto Revenue ", -1)
const _hoisted_16 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fab fa-btc fa-2x text-gray-300" })
], -1)
const _hoisted_18 = {
  key: 2,
  class: "col-xl-4 col-md-6 mb-4"
}
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = { class: "row no-gutters align-items-center" }
const _hoisted_21 = { class: "col mr-2" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-weight-bold text-primary text-uppercase mb-1" }, " Total Revenue ", -1)
const _hoisted_23 = { class: "h5 mb-0 font-weight-bold text-gray-800" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-university fa-2x text-gray-300" })
], -1)
const _hoisted_25 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (!_ctx.$permissions.generals['fiat_revenue'])
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", {
              class: ["card dashboard-top-card border-left-success shadow h-100 py-2", { active: _ctx.$route.path == '/revenues/fiat'}],
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.moveTo('/revenues/fiat')))
            }, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("div", _hoisted_9, _toDisplayString('2.9024 BTC'), 1)
                  ]),
                  _hoisted_10
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.$permissions.generals['crypto_revenue'])
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode("div", {
              class: ["card dashboard-top-card border-left-warning shadow h-100 py-2", {
            active: _ctx.$route.path == '/revenues/crypto',
          }],
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.moveTo('/revenues/crypto')))
            }, [
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode("div", _hoisted_16, _toDisplayString('2.4936 BTC'), 1)
                  ]),
                  _hoisted_17
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.$permissions.generals['total_revenue'])
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _createVNode("div", {
              class: ["card dashboard-top-card border-left-primary shadow h-100 py-2", {
            active: _ctx.$route.path == '/revenues/total',
          }],
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.moveTo('/revenues/total')))
            }, [
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode("div", _hoisted_23, _toDisplayString('5.3960 BTC'), 1)
                  ]),
                  _hoisted_24
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    (this.$route.path != '/revenues')
      ? (_openBlock(), _createBlock("div", _hoisted_25, [
          _createVNode(_component_router_view, {
            key: _ctx.$route.path
          }, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}